<template>
  <div class="section" :class="main_color">
    <div class="part part-avis-generaux" v-if="active_study.etudeData.projet_urbain">
      <div class="tle-row">
        <div class="tle-col half mapComponent" :class="{no_edit: editor.mode != 'editing'}" :style="{'z-index': editor.mode == 'editing' ? 100000 : 0}">
            <map-component
              class="q-mb-sm"
              suffix="2"
              :text_only_program="true"
            ></map-component>
            <el-image
              :parent_data="active_study.etudeData.projet_urbain.illustrations[1]"
              property="src"
              :editable="true"
              max_height="255px"
              v-if="active_study.etudeData.projet_urbain.illustrations"
            />
            <div class="tle-row set-width" style="max-width:100%;z-index:1000000;margin-left: 8px;margin-top: 8px;">
                <span style="margin-right: 4px;">Source : </span>
                <el-textarea
                    :parent_data="active_study.etudeData.projet_urbain"
                    property="source_image"
                    :editable="true"
                    height='20px'
                    overflow_edit='hidden scroll'
                    placeholder="Préciser"
                />
            </div>
        </div>
        <div class="tle-col half">
            <p class="label main_color_text">Prix des programmes du projet urbain</p>
            <el-table :table="table_prix" variant="tags" />
            <el-image
              :parent_data="active_study.etudeData.projet_urbain.illustrations[0]"
              property="src"
              :editable="true"
              max_height="382px"
              v-if="active_study.etudeData.projet_urbain.illustrations"
            />
        </div>
      </div>
      <div class="tle-row">
         <div class="tle-col half">
            <p class="label-small">L'impact des aménagements et équipements sur l'attractivité du quartier du projet d'aménagement</p>
            <el-mean-slider
                :parent_data="active_study.etudeData.projet_urbain"
                property="impact_amenagement"
                :max="10" :show_max="false"
                :values="['Faible', 'Fort']"
                :labels="[]"
                :rootComponent="active_study.etudeData.projet_urbain"
                :editable="true"
            />
            <p class="label-small">Positionnement du projet dans le programme</p>
            <el-mean-slider
                :parent_data="active_study.etudeData.projet_urbain"
                property="avancee"
                :max="10" :show_max="false"
                :values="['Début du projet urbain', 'Projet urbain achevé']"
                :labels="[]"
                :rootComponent="active_study.etudeData.projet_urbain"
                :editable="true"
            />
            
            <p class="label-small">Niveau d'attractivité actuel du site</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.projet_urbain.attractivite"
              property="actuelle"
              :max="10"
              :editable="true"
              :labels="['Entrée de gamme', 'Moyenne', 'Supérieure', 'Prestige']"
            />
            
            <p class="label-small">Niveau d'attractivité à la livraison du projet</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.projet_urbain.attractivite"
              property="livraison"
              :max="10"
              :editable="true"
              :labels="['Entrée de gamme', 'Moyenne', 'Supérieure', 'Prestige']"
            />
            
            <p class="label-small">Niveau d'attractivité à l'achèvement du projet urbain</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.projet_urbain.attractivite"
              property="achevement"
              :max="10"
              :editable="true"
              :labels="['Entrée de gamme', 'Moyenne', 'Supérieure', 'Prestige']"
            />
         </div>
         <div class="tle-col half">
            <div class="comment dense">
                <el-textarea
                    :parent_data="active_study.etudeData.projet_urbain"
                    property="commentaire"
                    :editable="true"
                    height='225px'
                    overflow_edit='hidden scroll'
                    placeholder="Commentaires CE/consultants"
                />
            </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import MapComponent from "@/components/study/editor/elements/MapComponent";

export default {
	name: "section-projet-urbain",
	mixins: [PageMixin],
	data: function () {
		return {
			key: 0
		};
	},
	props: {
		main_color: { default: "dark_red" }
	},

	computed: {
		...mapGetters(["active_study", "editor"]),
		table_prix: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [60, 40]
				}
			};
			if (this.active_study && this.active_study.etudeData && this.active_study.etudeData.projet_urbain && this.active_study.etudeData.projet_urbain.prix) {
				table.body.push([
					{ value: "Collectif sans stat." },
					{
						parent_data: this.active_study.etudeData.projet_urbain.prix,
						property: "collectif_sans_parking",
						editable: true,
						suffix: " €/m²"
					}]);
				table.body.push([
					{ value: "Individuel avec stat." },
					{
						parent_data: this.active_study.etudeData.projet_urbain.prix,
						property: "individuel_avec_parking",
						editable: true,
						suffix: " €"
					}
				]);
			}

			return table;
		}
	},
	methods: {
	},
	mounted: function () {
	},
	components: {
		MapComponent
	},
	watch: {
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

ul
  list-style-type none !important

.td-cb
  min-width 120px
  width 60%

.td-price
  width 40%

.priorite
  text-align center
  line-height 1.5
  font-size 18px

  .input
    min-height @line-height * 1
    max-height @line-height * 1
</style>
<style lang="stylus">
.part-avis-generaux
    .commentaire
        widht 100%
    .set-width
        display flex
        .el-textarea
            min-width 275px
</style>

